export enum adminRecruitmentDetailTypes {
    FETCH_ADMIN_RECRUITMENT_DETAIL_REQUEST = "FETCH_ADMIN_RECRUITMENT_DETAIL_REQUEST",
    FETCH_ADMIN_RECRUITMENT_DETAIL_SUCCESS = "FETCH_ADMIN_RECRUITMENT_DETAIL_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_DETAIL_FAILURE = "FETCH_ADMIN_RECRUITMENT_DETAIL_FAILURE",
  }